module.exports = __webpack_public_path__ + "img/nkbj.c9759917.png";